import React from 'react';

export default function ArrowLeftIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <g
        id="arrow_backward"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g
          id="ic/arrow_forward_ios"
          transform="translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) translate(3.000000, 3.000000)">
          <g>
            <mask id="mask-2-left" fill="white">
              <polygon
                id="path-1"
                points="4.41 3.09 10.32 9 4.41 14.91 6 16.5 13.5 9 6 1.5"></polygon>
            </mask>
            <g id="Path" fillRule="nonzero"></g>
            <g
              id="Dark-neutral-/-DN080"
              mask="url(#mask-2-left)"
              fill="#475262">
              <polygon id="DN80" points="0 18 18 18 18 0 0 0"></polygon>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
